var VerticalBarChartModule = /** @class */ (function () {
    function VerticalBarChartModule() {
    }
    return VerticalBarChartModule;
}());
export { VerticalBarChartModule };
